import datacentral from '@/utils/axios/datacentral'
import { ResponseArray, ResponseObject } from '@/types/shared'
import {
    CreateProductPricePayload,
    ProductPrice,
    UpdateProductPricePayload,
} from '../types/product-price'

const getBaseUrl = (productId: number) => `/products/${productId}/prices`

export const getProductPrices = async (
    productId: number,
    currency?: string
): Promise<ProductPrice[]> => {
    const params = currency ? { currency } : {}
    const response = await datacentral.get<ResponseArray<ProductPrice>>(
        getBaseUrl(productId),
        { params }
    )
    return response.data.results || []
}

export const createProductPrice = async (
    productId: number,
    payload: CreateProductPricePayload
): Promise<ProductPrice> => {
    const response = await datacentral.post<ResponseObject<ProductPrice>>(
        getBaseUrl(productId),
        payload
    )
    return response.data.result
}

export const updateProductPrice = async (
    productId: number,
    priceId: number,
    payload: UpdateProductPricePayload
): Promise<ProductPrice> => {
    const response = await datacentral.put<ResponseObject<ProductPrice>>(
        `${getBaseUrl(productId)}/${priceId}`,
        payload
    )
    return response.data.result
}

export const deleteProductPrice = async (
    productId: number,
    priceId: number
): Promise<void> => {
    await datacentral.delete(`${getBaseUrl(productId)}/${priceId}`)
}
